<template>
  <v-card
    width="100%"
    class="my-2 mx-0"
    color="grey lighten-4"
    hover
  >
    <v-card-text>
      <v-container
        fluid
        class="pa-0"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <v-col
            cols="12"
            class="py-0 px-0"
          >
            <v-row
              align="center"
              justify="space-between"
              class="ma-0"
            >
              <v-col
                class="px-0 py-1"
              >
                <v-row
                  align="center"
                  class="ma-0"
                >
                  <v-col
                    cols="10"
                    class="pa-0 ma-0 d-flex align-center"
                  >
                    <v-icon
                      color="green"
                      small
                      :class="{
                        'spinning': isProcessing
                      }"
                      v-text="isProcessing ? $vuetify.icons.values['mdiSync'] : $vuetify.icons.values['mdiLeaf']"
                    />
                    <v-flex class="d-flex flex-column text-break ml-2">
                      <span
                        class="body-2 font-weight-bold"
                        v-text="analysisTypeDisplay"
                      />
                      <span
                        class="caption font-weight-light status--text"
                        :class="statusClass"
                        v-text="statusText"
                      />
                    </v-flex>
                  </v-col>
                  <v-col
                    cols="2"
                    class="pa-0 ma-0 d-flex justify-end"
                  >
                    <post-processing-result-analysis-downloads
                      :id-field-post-processing="postProcessingAnalysis['cd_field_post_processing']"
                      :analysis-type="postProcessingAnalysis['ab_analysis_type']"
                    >
                      <template v-slot:activator="{ on: dialog}">
                        <v-tooltip right>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              v-if="isEnded"
                              icon
                              color="accent"
                              v-on="{...dialog, ...tooltip}"
                            >
                              <v-icon small>mdi-cloud-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Downloads</span>
                        </v-tooltip>
                      </template>
                    </post-processing-result-analysis-downloads>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider
              v-if="hasPostProcessingsAnalysisFields"
            />
            <v-expand-transition>
              <v-row
                v-if="hasPostProcessingsAnalysisFields"
                class="ma-0"
              >
                <v-col
                  cols="12"
                  v-for="ppaf in postProcessingsAnalysisFields"
                  :key="ppaf['id_post_processing_analysis_field']"
                >
                  <post-processing-result-analysis-field
                    :post-processing-analysis-field="ppaf"
                  />
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    ANALYSIS_TYPES_NAMES,
    POST_PROCESSING_STATUS,
    POST_PROCESSINGS_STATUS_NAMES,
  } from "../../../../helpers/post-processings/constants"
  import PostProcessingResultAnalysisDownloads from "./PostProcessingResultAnalysisDownloads"
  import {filter, includes, map, sortBy} from "lodash/collection"
  import {isEmpty, isEqual} from "lodash/lang"
  import PostProcessingResultAnalysisField from "./PostProcessingResultAnalysisField"

  const _Fields = Symbol.for("_Fields")

  export default {
    name: "PostProcessingResultAnalysisCard",
    inject: {_Fields},
    components: {PostProcessingResultAnalysisField, PostProcessingResultAnalysisDownloads},
    props: {
      postProcessingAnalysis: {
        type: Object,
        required: true
      }
    },
    filters: {},
    computed: {
      Fields() {
        return this._Fields()
      },
      postProcessingsAnalysisFields() {
        const cdFields = map(this.Fields, x => x["field"]["id_field"])

        const postProcessingsAnalysisFields = this.postProcessingAnalysis["post_processings_analysis_fields"]
        const filteredFields = filter(postProcessingsAnalysisFields, x => {
          return (
            includes(cdFields, x["field"]["id_field"]) &&
            includes([POST_PROCESSING_STATUS.ENDED, POST_PROCESSING_STATUS.ERROR], x["ab_status"])
          )
        })
        return sortBy(filteredFields, x => x["field"]["id_field"])
      },
      hasPostProcessingsAnalysisFields() {
        return !isEmpty(this.postProcessingsAnalysisFields)
      },
      analysisTypeDisplay() {
        const analysisType = this.postProcessingAnalysis['ab_analysis_type']
        if (!analysisType) return ""

        const displayName = ANALYSIS_TYPES_NAMES[analysisType]
        if (!displayName) return "Análise desconhecida"

        return displayName
      },
      statusText() {
        const abStatus = this.postProcessingAnalysis['ab_status']
        if (!abStatus) return ""

        const status = POST_PROCESSINGS_STATUS_NAMES[abStatus]
        if (!status) return ""

        return status["text"]
      },
      statusClass() {
        const abStatus = this.postProcessingAnalysis['ab_status']
        if (!abStatus) return ""

        const status = POST_PROCESSINGS_STATUS_NAMES[abStatus]
        if (!status) return ""

        return status["class"]
      },
      isProcessing() {
        const abStatus = this.postProcessingAnalysis['ab_status']
        if (!abStatus) return false

        return isEqual(abStatus, POST_PROCESSING_STATUS.PROCESSING)
      },
      isEnded() {
        const abStatus = this.postProcessingAnalysis['ab_status']
        if (!abStatus) return false

        return isEqual(abStatus, POST_PROCESSING_STATUS.ENDED)
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
